import React from 'react';
import '../App.css';
import WelComeLayer from '../components/WelcomeLayer'
import 'bootstrap/dist/css/bootstrap.min.css';
import InscriptionMain from "../components/InscriptionMain";
import {IMAGES, MESSAGES} from "../util/Messages";


class InscriptionApp extends React.Component {
  render() {
    return (
      <>
        <WelComeLayer logo={IMAGES.colsubidio}
        footer={IMAGES.footerColsubsidio}
        message={MESSAGES.WELCOME_MESSAGE_COLSUBSIDIO}
        />
        <InscriptionMain />
      </>
    );
  }
}

export default InscriptionApp;
